const list = [
  { id: '2', name: 'Casas residenciais' },
  { id: '3', name: 'Predios residenciais' },
  { id: '4', name: 'Predios comerciais' },
  { id: '5', name: 'Terrenos ou lotes residenciais' },
  { id: '6', name: 'Terrenos ou lotes comerciais' },
  { id: '7', name: 'Chacaras' },
  { id: '8', name: 'Residencial' },
  { id: '9', name: 'Comercial' },
  { id: '11', name: 'Galpoes Comerciais' },
  { id: '12', name: 'Industrial' },
  { id: '14', name: 'Hotel' },
];

export default list;
